module.exports = __webpack_public_path__ + "static/media/page-form.c634aada.svg";